// ==================== VALIDASI PTW UTAMA ====================

export const validatePTWForm = (formData) => {
  const errors = {};

  // Step 1: Info Umum
  if (!formData.lokasi_pekerjaan?.trim()) {
    errors.lokasi_pekerjaan = 'Lokasi pekerjaan wajib diisi';
  }
  if (!formData.deskripsi_pekerjaan?.trim()) {
    errors.deskripsi_pekerjaan = 'Deskripsi pekerjaan wajib diisi';
  }
  if (!formData.tanggal_mulai) {
    errors.tanggal_mulai = 'Tanggal mulai wajib dipilih';
  }
  if (!formData.mobile_phone_1?.trim()) {
    errors.mobile_phone_1 = 'Nomor HP 1 wajib diisi';
  }
  if (!formData.mobile_phone_2?.trim()) {
    errors.mobile_phone_2 = 'Nomor HP 2 wajib diisi';
  }
  
  // Validasi nama pekerja: minimal 1, tidak boleh kosong
  const validNamaPekerja = formData.nama_pekerja?.filter(n => n?.trim()).length > 0;
  if (!validNamaPekerja) {
    errors.nama_pekerja = 'Minimal 1 nama pekerja wajib diisi';
  }

  // Step 2: JSA - minimal 1 baris dengan steps_of_activity terisi
  const hasValidJSA = formData.jsa_table?.some(row => row.steps_of_activity?.trim());
  if (!hasValidJSA) {
    errors.jsa_table = 'JSA wajib diisi minimal 1 baris dengan langkah aktivitas';
  }

  // Step Review: PIC wajib dipilih
  if (!formData.pic_id) {
    errors.pic_id = 'PIC wajib dipilih';
  }

  return errors;
};

// ==================== VALIDASI WORKING AT HEIGHT ====================

export const validateWorkingAtHeight = (formData, namaPekerjaList = []) => {
  const errors = {};

  const wah = formData.high_risk_forms?.working_at_height;
  if (!wah) return errors;

  // Disclaimer
  if (!wah.workers_trained_disclaimer) {
    errors.wah_disclaimer = 'Disclaimer pekerja terlatih wajib dicentang';
  }
  if (!wah.guidelines_acknowledged) {
    errors.wah_guidelines = 'Guidelines wajib disetujui';
  }

  // Tensi pekerja - setiap pekerja wajib
  if (namaPekerjaList && namaPekerjaList.length > 0) {
    const tensiList = wah.tensi_pekerja || [];
    for (let i = 0; i < namaPekerjaList.length; i++) {
      const tensi = tensiList.find(t => t.nama === namaPekerjaList[i]) || {};
      if (!tensi.tekanan_darah?.trim()) {
        errors[`wah_tensi_${i}`] = `Tekanan darah untuk ${namaPekerjaList[i]} wajib diisi`;
      }
    }
  }

  // Power Supply
  if (!wah.power_supply_area_clear) {
    errors.wah_power_supply = 'Pengecekan area listrik wajib dipilih';
  }

  // Ladder Checks (semua wajib)
  const ladderFields = [
    'ladder_condition_good',
    'area_safe_movement',
    'aluminum_ladder_electric_area',
    'equipment_belt_attached',
    'ladder_pedestrian_positioned',
    'ladder_lock_secured',
    'ladder_extension_proper'
  ];
  ladderFields.forEach(field => {
    if (!wah[field]) {
      errors[`wah_${field}`] = 'Field ini wajib dipilih';
    }
  });

  // Forklift & Platform Checks
  const forkliftFields = [
    'forklift_platform_licensed',
    'forklift_area_clear_electric',
    'forklift_fall_harness_used',
    'forklift_mobile_platform_osha',
    'scaffolding_osha_compliant',
    'scaffolding_toe_guard_rails',
    'mobile_scaffolding_locked',
    'outrigger_installed',
    'work_area_clear_electric'
  ];
  forkliftFields.forEach(field => {
    if (!wah[field]) {
      errors[`wah_${field}`] = 'Field ini wajib dipilih';
    }
  });

  // Precaution
  if (!wah.precaution_barricade) {
    errors.wah_barricade = 'Barricade wajib dipasang';
  }
  if (!wah.precaution_special_warning?.trim()) {
    errors.wah_special_warning = 'Informasi tensi pekerja wajib diisi';
  }

  return errors;
};

// ==================== VALIDASI HOT WORK ====================

export const validateHotWork = (formData) => {
  const errors = {};
  const hw = formData.high_risk_forms?.hot_work;
  if (!hw) return errors;

  // Disclaimer
  if (!hw.warning_sign_disclaimer) {
    errors.hw_disclaimer = 'Warning sign disclaimer wajib dicentang';
  }

  // Checklist
  const checklistFields = [
    'checklist_sprinkler_hydrant',
    'checklist_equipment_condition',
    'checklist_fire_extinguisher'
  ];
  checklistFields.forEach(field => {
    if (!hw[field]) {
      errors[`hw_${field}`] = 'Field ini wajib dipilih';
    }
  });

  // Area 12m
  const areaFields = [
    'area_12m_material_cleared',
    'area_12m_no_explosive',
    'area_12m_floor_protected',
    'area_12m_walls_openings_protected',
    'area_12m_passage_closed'
  ];
  areaFields.forEach(field => {
    if (!hw[field]) {
      errors[`hw_${field}`] = 'Field ini wajib dipilih';
    }
  });

  // Wall/Ceiling
  if (!hw.wall_ceiling_combustible) {
    errors.hw_wall_ceiling_combustible = 'Pertanyaan material dinding wajib dipilih';
  }
  // Conditional: jika combustible = "Ya", maka isolated wajib
  if (hw.wall_ceiling_combustible === 'Ya' && !hw.wall_ceiling_isolated) {
    errors.hw_wall_ceiling_isolated = 'Isolasi dinding wajib dipilih karena material combustible';
  }

  // Monitoring
  const monitoringFields = [
    'monitoring_fire_watch_2hrs',
    'monitoring_she_has_extinguisher',
    'monitoring_she_trained'
  ];
  monitoringFields.forEach(field => {
    if (!hw[field]) {
      errors[`hw_${field}`] = 'Field ini wajib dipilih';
    }
  });

  return errors;
};

// ==================== VALIDASI ELECTRIC MEDIUM VOLTAGE ====================

export const validateElectricMediumVoltage = (formData) => {
  const errors = {};
  const emv = formData.high_risk_forms?.electric_medium_voltage;
  if (!emv) return errors;

  // Disclaimer
  if (!emv.workers_briefing_disclaimer) {
    errors.emv_disclaimer = 'Worker briefing disclaimer wajib dicentang';
  }

  // Checklist MV (semua wajib)
  const checklistFields = [
    'checklist_outgoing_switch_off',
    'checklist_outgoing_grounded',
    'checklist_outgoing_ground_point',
    'checklist_incoming_switch_off',
    'checklist_incoming_busbar_grounded',
    'checklist_incoming_ground_point',
    'checklist_voltmeter_off',
    'checklist_incoming_breaker_loto',
    'checklist_outgoing_breaker_loto',
    'checklist_manual_clamp_grounding',
    'checklist_incoming_cable_off',
    'checklist_transformer_ground_ok'
  ];
  checklistFields.forEach(field => {
    if (!emv[field]) {
      errors[`emv_${field}`] = 'Field ini wajib dipilih';
    }
  });

  // Isolation
  const isolationFields = [
    'isolation_uniform_safety_shoes',
    'isolation_electric_gloves',
    'isolation_safety_glasses',
    'isolation_tools_certified',
    'isolation_work_at_height_permit',
    'isolation_fire_extinguisher_abc'
  ];
  isolationFields.forEach(field => {
    if (!emv[field]) {
      errors[`emv_${field}`] = 'Field ini wajib dipilih';
    }
  });

  return errors;
};

// ==================== VALIDASI CONFINED SPACE ====================

export const validateConfinedSpace = (formData, hazardControlsTable, ventilasiData, permitReview, monitoringUdaraTerusMenerus, emergencyProcedure, qsheProcedure) => {
  const errors = {};
  const cs = formData.high_risk_forms?.confined_space;
  if (!cs) return errors;

  // Declaration
  if (!cs.declaration_understand_work) {
    errors.cs_declaration = 'Deklarasi confined space wajib dicentang';
  }

  // Hazard Controls Table - setiap baris wajib pilih YA atau TIDAK
  if (hazardControlsTable && hazardControlsTable.length > 0) {
    hazardControlsTable.forEach((row, idx) => {
      if (row.ya === false && row.tidak === false) {
        errors[`cs_hazard_table_${idx}`] = `Baris "${row.pertanyaan}" wajib dipilih YA atau TIDAK`;
      }
    });
  }

  // Ventilasi
  if (!ventilasiData.cukup) {
    errors.cs_ventilasi_cukup = 'Pertanyaan ventilasi wajib diisi';
  }
  if (ventilasiData.cukup === 'Tidak' && !ventilasiData.jenis) {
    errors.cs_ventilasi_jenis = 'Jenis ventilasi wajib diisi';
  }

  // Permit Review (semua wajib)
  const permitReviewFields = [
    'monitoring_udara',
    'respirator_diperlukan',
    'hazard_controls_ppe',
    'plant_safety_approval',
    'monitoring_berkelanjutan'
  ];
  permitReviewFields.forEach(field => {
    if (!permitReview[field]) {
      errors[`permit_review_${field}`] = 'Pertanyaan ini wajib diisi';
    }
  });

  // Monitoring Udara Terus Menerus
  if (!monitoringUdaraTerusMenerus) {
    errors.monitoring_udara_terus_menerus = 'Pertanyaan monitoring udara wajib diisi';
  }

  // Emergency Procedure
  if (!emergencyProcedure) {
    errors.emergency_procedure = 'Emergency procedure wajib dipilih';
  }

  // QSHE Procedure
  if (!qsheProcedure.guidelines || qsheProcedure.guidelines.length === 0) {
    errors.qshe_guidelines = 'Minimal satu guideline wajib dipilih';
  }
  if (!qsheProcedure.nama_procedure?.trim()) {
    errors.qshe_nama_procedure = 'Nama procedure wajib diisi';
  }
  if (!qsheProcedure.risk_assessment) {
    errors.qshe_risk_assessment = 'Risk assessment wajib dipilih';
  }

  // Hot Work conditional validation
  if (!cs.hot_work_welding_exists) {
    errors.cs_hot_work_welding_exists = 'Pertanyaan hot work wajib diisi';
  }
  if (cs.hot_work_welding_exists === 'Ya') {
    if (!cs.hot_work_cert_asme) {
      errors.cs_hot_work_cert = 'Sertifikasi ASME wajib dipilih';
    }
    if (!cs.hot_work_equipment_list?.trim()) {
      errors.cs_hot_work_equipment = 'List peralatan hot work wajib diisi';
    }
    if (!cs.hot_work_cylinder_certified) {
      errors.cs_hot_work_cylinder = 'Sertifikasi tabung wajib dipilih';
    }
    if (!cs.hot_work_hose_condition) {
      errors.cs_hot_work_hose = 'Kondisi hose wajib dipilih';
    }
    if (!cs.hot_work_coupling_condition) {
      errors.cs_hot_work_coupling = 'Kondisi coupling wajib dipilih';
    }
  }

  return errors;
};

// ==================== VALIDASI CLOSING ====================

export const validateClosing = (closingData, closingChecklistItems) => {
  const errors = {};

  // Semua checklist wajib dicentang
  closingChecklistItems.forEach(item => {
    if (!closingData.closing_checklist?.[item.key]) {
      errors[`closing_${item.key}`] = `"${item.label}" wajib dicentang`;
    }
  });

  // Disclaimer wajib
  if (!closingData.closing_disclaimer_accepted) {
    errors.closing_disclaimer = 'Disclaimer closing wajib disetujui';
  }

  return errors;
};

// ==================== VALIDASI GABUNGAN UNTUK HIGH RISK FORMS ====================

export const validateAllHighRiskForms = (formData, extraStates) => {
  let allErrors = {};

  if (formData.high_risk_activities?.includes('Working at Height')) {
    allErrors = { ...allErrors, ...validateWorkingAtHeight(formData, formData.nama_pekerja) };
  }
  if (formData.high_risk_activities?.includes('Hot Work')) {
    allErrors = { ...allErrors, ...validateHotWork(formData) };
  }
  if (formData.high_risk_activities?.includes('Electric Medium Voltage')) {
    allErrors = { ...allErrors, ...validateElectricMediumVoltage(formData) };
  }
  if (formData.high_risk_activities?.includes('Confined Space')) {
    allErrors = { ...allErrors, ...validateConfinedSpace(
      formData,
      extraStates.hazardControlsTable,
      extraStates.ventilasiData,
      extraStates.permitReview,
      extraStates.monitoringUdaraTerusMenerus,
      extraStates.emergencyProcedure,
      extraStates.qsheProcedure
    ) };
  }

  return allErrors;
};